export default __webpack_public_path__ + "static/media/wind-turbine-existing-highlighted-icon.8ce940a2.svg";